export const comments_3389029 = {"data":{"data":[],"links":{}}}